export enum BalanceType {
  Credit = "credit",
  Money = "money",
}

export enum UserRole {
  Admin = "admin",
  SubAdmin = "sub_admin",
  // Sells credit from its own pool to the agents and dealers it opened; sees
  // nothing else of the panel or the site.
  CreditSeller = "credit_seller",
  Agent = "agent",
  Dealer = "dealer",
  SubDealer = "sub_dealer",
  User = "user",
}

export type RoleMatch = UserRole | UserRole[];

export enum StepUpMethod {
  Password = "password",
  Totp = "totp",
  Telegram = "telegram",
}

export interface UserProfile {
  image: string | null;
}

export interface UserSummary {
  id: number;
  username: string;
  role: string;
  image: string | null;
}

// Role breakdown of a user's subtree, returned by the agent/dealer/sub-dealer
// list endpoints so the admin tables can show counts at a glance.
export interface HierarchyCounts {
  agents: number;
  dealers: number;
  subDealers: number;
  players: number;
}

export interface NewUser {
  id: number;
  username: string;
  role: UserRole;
  agentId: number | null;
  dealerId: number | null;
  subDealerId: number | null;
  agent: UserSummary | null;
  dealer: UserSummary | null;
  subDealer: UserSummary | null;
  // The account that opened this one (null for accounts older than the
  // column). `creator` is resolved only by the credit seller list.
  createdById?: number | null;
  creator?: UserSummary | null;
  email: string | null;
  image: string | null;
  balance: number;
  balanceType: BalanceType;
  banned: boolean;
  banReason: string | null;
  banExpires: string | null;
  bettingRulesLocked?: boolean;
  // Present on the players list: a live socket was reported for this user
  // within the presence window. Absent on endpoints that do not read it.
  isOnline?: boolean;
  // Present on dealer list rows only (real-money casino enablement).
  casinoRealEnabled?: boolean;
  maintenanceMode?: "manual" | "scheduled";
  maintenanceEnabled?: boolean;
  maintenanceStartAt?: string | null;
  maintenanceEndAt?: string | null;
  maintenanceMessage?: string;
  createdAt: string;
  updatedAt: string;
  lastLoginAt: string | null;
  hasStepUpPassword: boolean;
  stepUpMethod: StepUpMethod;
  hasTotp: boolean;
  hasTelegram: boolean;
  // Subtree counts (present on agent/dealer/sub-dealer list rows). Optional so
  // other endpoints returning NewUser without counts stay compatible.
  counts?: HierarchyCounts;
}
